<template>
  <b-modal
    id="webhook-save-modal"
    ref="webhookSaveModal"
    :title="`${update ? 'Update': 'Create New'} Webhook`"
    hide-footer
    size="lg"
    @hidden="clear">
    <b-form-group>
      <SwitchCheckbox
        id="webhook-active"
        v-model="activeWebhook"
        class="float-left"
        size="mini"/>
      <label
        for="webhook-active"
        class="checkbox-label">
        Active
      </label>
    </b-form-group>
    <b-form-group>
      <label
        class="col-form-label pt-0">
        Webhook URL
      </label>
      <b-input
        v-model="url"
        autofocus
        :disabled="update"
        name="url"
        data-vv-as="URL"
        placeholder="Add URL"/>
      <span
        v-if="validationErrors.url"
        class="validation-error clearfix">
        {{ validationErrors.url }}
      </span>
    </b-form-group>
    <b-form-group>
      <label class="col-form-label pt-0">
        Webhooks to send
      </label>
      <b-form-checkbox-group
        v-model="selectedWebhookTypes"
        class="check-list">
        <b-col
          v-for="(webhookTypes, category) in webhookCategories"
          :key="category"
          md="6"
          sm="12">
          <label class="col-form-label pt-0 text-capitalize">
            {{ category }}
          </label>
          <div
            v-for="webhookType in webhookTypes"
            :key="webhookType">
            <b-check :value="webhookType">
              {{ webhookType }}
            </b-check>
          </div>
        </b-col>
      </b-form-checkbox-group>
      <span
        v-if="validationErrors.types"
        class="validation-error clearfix">
        {{ validationErrors.types }}
      </span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="saveWebhook">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SwitchCheckbox from '../../../../common/SwitchCheckbox';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'WebhookSaveModal',
  components: {
    SwitchCheckbox,
  },
  props: {
    webhookp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      url: '',
      selectedWebhookTypes: [],
      activeWebhook: true,
      update: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      webhookCategories: 'webhook/webhookTypes',
      webhookSaved: 'webhook/webhookSaved',
      apiError: 'webhook/apiError',
    }),
  },
  watch: {
    webhookSaved(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', saved);
        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    if (!this.webhookCategories.length) {
      this.fetchWebhookTypes(this.$route.params.merchant_id);
    }
  },
  methods: {
    ...mapActions({
      fetchWebhookTypes: 'webhook/fetchWebhookTypes',
      createWebhook: 'webhook/createWebhook',
      updateWebhook: 'webhook/updateWebhook',
    }),
    setWebhookData() {
      if (!this.$lodash.isEmpty(this.webhookp)) {
        this.update = true;
        this.activeWebhook = this.webhookp.active;
        this.url = this.webhookp.url;
        this.selectedWebhookTypes = this.webhookp.selected_webhooks;
      } else {
        this.clear();
      }
    },
    saveWebhook() {
      this.saving = true;
      this.validationErrors = {};
      const data = {
        active: this.activeWebhook,
        url: this.url,
        types: this.selectedWebhookTypes,
      };

      if (this.update) {
        this.updateWebhook({
          merchant_id: this.$route.params.merchant_id,
          webhook_id: this.webhookp.id,
          data,
        });
      } else {
        this.createWebhook({
          merchant_id: this.$route.params.merchant_id,
          data,
        });
      }
    },
    show() {
      this.setWebhookData();
      this.$refs.webhookSaveModal.show();
    },
    clear() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hide() {
      this.$refs.webhookSaveModal.hide();
    },
  },
};
</script>
